import React from 'react';
import { useTranslation } from 'react-i18next';
import Vale from '../Vales';
import { useValesMasivosContext } from '../context/ValesMasivos.context';

const ValesCanjeados = ({
  valesCanj,
  retrieveValesAhorro,
  isMobile,
  setVisible,
  setPromocion,
}) => {
  const { t, i18n } = useTranslation();
  const idiomaActual = i18n.language;
  const { cuponesMasivosCanjeados, formaterFecha } = useValesMasivosContext();

  const mostrarSeccion = () => {
    return valesCanj?.length > 0 || cuponesMasivosCanjeados?.length > 0;
  };
  return mostrarSeccion() ? (
    <>
      <div className="divider" />

      <h2 className="bloque-datos__title u-text-brand">
        <span className="divider__square brand-color" />
        <span className="u-margin-right">{t('vales.canjeados')}</span>
      </h2>

      {cuponesMasivosCanjeados.map(
        (cuponesMasivosCanjeadosSegmentado, index) => {
          return (
            <div
              className="listado-vales listado-vales__canjeados listado-vales--masivos"
              id={`lista-vales-masivos-${index}`}
            >
              <div className="listado-vales__header">
                <h3 className="listado-vales__header-title">{`${cuponesMasivosCanjeadosSegmentado[0].textoTitulo}`}</h3>
                <p>{`Compra realizada el ${formaterFecha(
                  cuponesMasivosCanjeadosSegmentado[0]
                    .fechaEmisionValeDigitalizado,
                  idiomaActual,
                )}`}</p>
              </div>
              <div
                className="listado-vales__list"
                id={`lista-vales_list-${index}`}
              >
                {cuponesMasivosCanjeadosSegmentado.map((valeData) => (
                  <Vale
                    preActivado={false}
                    key={`vale-${valeData.valeEAN}`}
                    data={{
                      ...valeData,
                      masivo: true,
                      tipoLista: 3,
                      grupoIndex: index,
                    }}
                    cargarVales={retrieveValesAhorro}
                    valeIndex={isMobile ? 0 : index}
                    showCondLegales={setVisible}
                    setPromocion={setPromocion}
                  />
                ))}
              </div>
            </div>
          );
        },
      )}

      <div className="listado-vales listado-vales__canjeados">
        {valesCanj &&
          valesCanj.map((valeData, index) => (
            <Vale
              setPromocion={setPromocion}
              preActivado={false}
              key={`vale-${valeData.valeEAN}`}
              data={valeData}
              cargarVales={retrieveValesAhorro}
              valeIndex={isMobile ? 0 : index}
              showCondLegales={setVisible}
            />
          ))}
      </div>
    </>
  ) : null;
};

export default ValesCanjeados;
